/**
 * ATT-2871 admin half — synchronous bundled-config hydration.
 *
 * Called from `pages/_app.tsx` BEFORE any children render. Pushes the bundled
 * `getCurrentTenantConfig()` values into `useTenantSettingsStore`, so synchronous
 * helpers like `tenantHasFlag()` always see valid data — no race window.
 *
 * Per Phase 1.7 impact analyzer guidance: wrap in try/catch. On any throw
 * (e.g., `getCurrentTenantConfig()` errors during SSR, malformed bundled
 * config, etc.), capture a Sentry warning and leave the store at its safe
 * default. Hydrate MUST NEVER throw to its caller.
 */

import * as Sentry from "@sentry/nextjs";
import { getCurrentTenantConfig } from "../../config/tenants";
import { useTenantSettingsStore } from "./store";

export function hydrateTenantSettingsStoreFromBundled(): void {
  try {
    const bundled = getCurrentTenantConfig();
    useTenantSettingsStore.getState().setBundled({
      featureFlags: Array.isArray(bundled.featureFlags) ? bundled.featureFlags : [],
      logoUrl: typeof bundled.logoUrl === "string" ? bundled.logoUrl : null,
    });
  } catch (err) {
    Sentry.captureException(err, {
      tags: { event: "tenant-settings-hydrate-failed" },
      level: "warning",
    });
    // Store stays at its safe default (empty arrays / null) — never throws.
  }
}
